import { semanticPalette } from './semanticColor';

export type WhiteLabelPalette = {
  name: WhiteLabelPaletteName;
  palette: Record<keyof typeof semanticPalette.brand, string>;
};

export type WhiteLabelPaletteName = keyof typeof whiteLabelPalettes;

export const whiteLabelPalettes = {
  // The whiteout palette exists only to set an initial color theme before figuring out and applying the actual theme
  whiteout: {
    name: 'Whiteout',
    palette: {
      '100': '#FFFFFF',
      '200': '#FFFFFF',
      '300': '#FFFFFF',
      '500': '#FFFFFF',
      base: '#FFFFFF',
    },
  },
  crunchberry: {
    name: 'Crunchberry',
    palette: {
      '100': '#FDECF4',
      '200': '#E5A5C5',
      '300': '#F50B7C',
      '500': '#CC0D71',
      base: '#E30C79',
    },
  },
  cranberry: {
    name: 'Cranberry',
    palette: {
      '100': '#FFF0F0',
      '200': '#DB9696',
      '300': '#E40037',
      '500': '#A80003',
      base: '#B8002C',
    },
  },
  pomegranate: {
    name: 'Pomegranate',
    palette: {
      '100': '#FFE5E5',
      '200': '#DB9A9A',
      '300': '#E21700',
      '500': '#990F00',
      base: '#BD1300',
    },
  },
  papaya: {
    name: 'Papaya',
    palette: {
      '100': '#FFEDE3',
      '200': '#E3B093',
      '300': '#EA5500',
      '500': '#8A3200',
      base: '#BD4500',
    },
  },
  tangerine: {
    name: 'Tangerine',
    palette: {
      '200': '#FFF2E5',
      '100': '#E2BB93',
      '300': '#DA7500',
      '500': '#7A4100',
      base: '#A85A00',
    },
  },
  asiago: {
    name: 'Asiago',
    palette: {
      '100': '#FFF0C9',
      '200': '#D9C38C',
      '300': '#C89200',
      '500': '#664B00',
      base: '#8A6500',
    },
  },
  avocado: {
    name: 'Avocado',
    palette: {
      '100': '#EBFFCB',
      '200': '#AAC381',
      '300': '#6AAD00',
      '500': '#395C00',
      base: '#4B7A00',
    },
  },
  kiwi: {
    name: 'Kiwi',
    palette: {
      '100': '#E1FFF4',
      '200': '#8BC8B2',
      '300': '#00AD6E',
      '500': '#00613D',
      base: '#008051',
    },
  },
  cucumber: {
    name: 'Cucumber',
    palette: {
      '100': '#E1FFFB',
      '200': '#8CC8C1',
      '300': '#00A1AA',
      '500': '#005C61',
      base: '#007E85',
    },
  },
  braspberry: {
    name: 'BRaspberry',
    palette: {
      '100': '#E1F4FF',
      '200': '#94BBD0',
      '300': '#0087C1',
      '500': '#00567A',
      base: '#0072A3',
    },
  },
  blueberry: {
    name: 'Blueberry',
    palette: {
      '100': '#EBF7FF',
      '200': '#82B6D8',
      '300': '#5C8AFF',
      '500': '#003EDB',
      base: '#2462FF',
    },
  },
  blackberry: {
    name: 'Blackberry',
    palette: {
      '100': '#E2DFFF',
      '200': '#A09BD7',
      '300': '#7568FF',
      '500': '#1400F0',
      base: '#5242FF',
    },
  },
  taro: {
    name: 'Taro',
    palette: {
      '100': '#F0E0FF',
      '200': '#AE8CCE',
      '300': '#AD5CFF',
      '500': '#6300C7',
      base: '#8C1AFF',
    },
  },
  eggplant: {
    name: 'Eggplant',
    palette: {
      '100': '#F8E5FF',
      '200': '#C58EDA',
      '300': '#C62CFF',
      '500': '#7F00AD',
      base: '#A800E6',
    },
  },
  beet: {
    name: 'Beet',
    palette: {
      '100': '#FFE2F7',
      '200': '#DFA0CD',
      '300': '#DC009E',
      '500': '#94006A',
      base: '#A80079',
    },
  },
  plum: {
    name: 'Plum',
    palette: {
      '100': '#DADEEC',
      '200': '#8E9DCF',
      '300': '#576BCD',
      '500': '#334184',
      base: '#4655A0',
    },
  },
  licorice: {
    name: 'Licorice',
    palette: {
      '100': '#EDEDED',
      '200': '#9E9CAF',
      '300': '#636E7D',
      '500': '#3C424B',
      base: '#48505B',
    },
  },
} as const;
